
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reference/[square_version]/deprecated",
      function () {
        return require("private-next-pages/reference/[square_version]/deprecated/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reference/[square_version]/deprecated"])
      });
    }
  